// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3Xkp7","content":"LayoutSettings_content__2v_QM"};